import React from 'react';
import FinalizedAssignmentItem from '../../../../../Domain/FinalizedAssignmentItem';
import ErrorMessage from '../../../../../Elements/ErrorMessage';
import GeneralEditWizzardBase from '../../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import GeneralEditWizzardBaseFigma from '../../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import PopupInvoiceSelect from '../../../../../Elements/PopupInvoiceSelect';
import CrudTypesEnum from '../../../../../Enums/CrudTypesEnum';
import ShownPanelsEnum from '../../../../../Enums/ShownPanelsEnum';
import ProjectAssignmentService from '../../../../../Services/ProjectAssignmentsService';
import EditProjectAssignmentWindowDescription from '../EditProjectAssignmentWindowDescription';
import AssignmentsListBase from './AssignmentsListBase';
import contactService from '../../../../../Services/contactService';
import ButtonTypeEnum from '../../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../../Enums/IconPositionEnum';
import TabOfDataTable from '../../../../../Elements/DataTable/TabOfDataTable';
import ProjectAssignmentEditItem from '../../../../../Domain/ProjectAssignmentEditItem';
import FigmaButtonRow from '../../../../../Elements/FigmaButtonRow';
import AssignmentFinalizedSearchParams from '../AssignmentFinalizedSearchParams';
import EditClientInvoiceWindowDescription from '../../../ClientInvoiceAdmin/EditClientInvoiceWindowDescription';
import ClientInvoiceAdminItem from '../../../../../Domain/ClientInvoiceAdminItem';
import dateTimeHelper from '../../../../../Helpers/datetimeHelper';
import ClientItem from '../../../../../Domain/ClientItem';

export default class FinalizedAssignmentsList extends AssignmentsListBase {
  constructor(props) {
    super(props);

    this.clickOnUpdateMultipleButton = this.clickOnUpdateMultipleButton.bind(this);
    this.clickOnAddToInvoiceButton = this.clickOnAddToInvoiceButton.bind(this);
    this.clickOnGenerateInvoiceButton = this.clickOnGenerateInvoiceButton.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    EditProjectAssignmentWindowDescription.getSelected = this.getSelected.bind(this);
    EditProjectAssignmentWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    EditProjectAssignmentWindowDescription.getAllItemInTheSearchAreSelected =
      this.getAllItemInTheSearchAreSelected.bind(this);
    AssignmentFinalizedSearchParams.getClientId = () => this.getClientId();
  }

  getClientId() {
    return this.props.type === 'finalized' ? this.props.Item.CfCcid : this.props.Item.ClientId;
  }

  getAllItemInTheSearchAreSelected() {
    return this.state.allItemInTheSearchAreSelected;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  isAnyItemSelected() {
    return this.state.itemList.find((u) => u.Selected === true) !== undefined;
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    if (refresh) {
      this.refresh();
    }
  }

  clickOnUpdateMultipleButton(selectedId, selectedItem) {
    this.setState({
      selectedItem: new ProjectAssignmentEditItem(),
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  clickOnAddToInvoiceButton() {
    this.setState({
      selectedItem: null,
      shownPanel: ShownPanelsEnum.AddNewSubItem,
    });
  }

  clickOnGenerateInvoiceButton(selectedId, selectedItem) {
    const clientInvoice = new ClientInvoiceAdminItem();
    if (this.props.type === 'finalized') {
      clientInvoice.CiCcid = this.props.Item.CfCcid;
      clientInvoice.ClientName = this.props.Item.CfCcname;
    } else if (this.props.type === 'finalized_client') {
      clientInvoice.CiCcid = this.props.Item.ClientId;
      clientInvoice.ClientName = this.props.Item.Name;
    }

    clientInvoice.ServiceFeeId = 1;
    clientInvoice.CiCfid = this.props.Item.CfId;

    if (this.props.Item instanceof ClientItem) {
      clientInvoice.CiOfficeId = this.props.Item.OfficeId;
      clientInvoice.OfficeName = this.props.Item.OfficeName;
      clientInvoice.CiDaysToPay = this.props.Item.DaysToPayCode ? this.props.Item.DaysToPayCode : 30;
      clientInvoice.CiInterestRate = this.props.Item.InvoiceInterestRate ? this.props.Item.InvoiceInterestRate : 0;
    } else {
      clientInvoice.CiOfficeId = this.props.Item.CfLdvid;
      clientInvoice.OfficeName = this.props.Item.CfLdvname;
      clientInvoice.CiDaysToPay = this.props.Item.ClientDaysToPayCode ? this.props.Item.ClientDaysToPayCode : 30;
      clientInvoice.CiInterestRate = this.props.Item.ClientInvoiceInterestRate
        ? this.props.Item.ClientInvoiceInterestRate
        : 0;
    }

    clientInvoice.AsIds = [...this.getSelected().map((s) => s.AsId)];
    clientInvoice.AllItemsInTheSearchAreSelected = this.getAllItemInTheSearchAreSelected();
    clientInvoice.SearchParameters = null;
    if (clientInvoice.AllItemsInTheSearchAreSelected) {
      clientInvoice.SearchParameters = this.getSearchParameters();
    }
    clientInvoice.GenerationType = 'Assignment';

    if (clientInvoice.CiOfficeId === 9) {
      clientInvoice.FulfillmentDate = dateTimeHelper.addDaysToDate(dateTimeHelper.toYYYYsMMsDD(new Date()), 1);
    }

    contactService
      .GetContactListByClientId(clientInvoice.CiCcid, true)
      .then((contacts) => {
        clientInvoice.ClientContacts = contacts;

        ProjectAssignmentService.GetProjectAssignmentAdditionalInformation(clientInvoice.CiCcid)
          .then((result) => {
            const defaultReportName = EditClientInvoiceWindowDescription.getInvoiceFormOptions().find(
              (f) => f.label === result.ciDefaultReportName
            );
            clientInvoice.CiDefaultReportName = defaultReportName ? defaultReportName.value : '';
            clientInvoice.CiRcyid = result.billingCurId;

            this.setState({
              selectedItem: clientInvoice,
              shownPanel: ShownPanelsEnum.AddNewItem,
            });
          })
          .catch((error) => ErrorMessage.SetErrorMessage('FAL131'));
      })
      .catch((error) => ErrorMessage.SetErrorMessage('FAL133'));
  }

  renderActionButtons() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-rectangle-history-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnUpdateMultipleButton(this.state.selected, this.state.selectedItem),
            tooltip: 'Update Multiple',
            roleKey: 'assignment_edit',
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-file-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnAddToInvoiceButton(this.state.selected, this.state.selectedItem),
            tooltip: 'Add To Invoice',
            roleKey: 'assignment_edit',
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-rectangle-history-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnGenerateInvoiceButton(this.state.selected, this.state.selectedItem),
            tooltip: 'Generate Invoice',
            roleKey: 'assignment_edit',
          },
        ]}
      />
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            editedItem={this.state.selectedItem}
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={EditProjectAssignmentWindowDescription}
            errorCode={'FAL166'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBaseFigma
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={EditClientInvoiceWindowDescription}
            errorCode={'FAL176'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewSubItem,
          <PopupInvoiceSelect
            companyText=''
            allItemsInTheSearchAreSelected={this.getAllItemInTheSearchAreSelected()}
            searchParameters={this.getSearchParameters()}
            clientId={this.getClientId()}
            selectedAssignments={this.getSelected()}
            cancelButtonText='Cancel'
            okButtonText='Ok'
            closePopupFunction={() => this.editPanelOnClose(false)}
            okPopupFunction={() => this.editPanelOnClose(true)}
          />
        )}
      </div>
    );
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    return ProjectAssignmentService.GetAssignmentList(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      this.getSearchParameters(searchItem),
      clearCache
    );
  }

  getTabOfDataTable() {
    return (
      <div>
        {this.renderPanels()}
        <TabOfDataTable
          type={FinalizedAssignmentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={this.serviceFunction.bind(this)}
          convertDBItemsFunction={ProjectAssignmentService.ConvertFinalizedClientDbItems}
          searchItem={this.state.searchItem}
          searchParamsType={AssignmentFinalizedSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          changeOfAllItemsAreSelectedFunction={(allItemInTheSearchAreSelected) => {
            this.setState({ allItemInTheSearchAreSelected });
          }}
          itemTypeName={'assignments'}
          enableUrlPush={false}
          errorCode='FAL324'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Apollo/Location ID and country code...'
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
